/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snap_To_Shot_Changes_DescriptionInputs */

const en_snap_to_shot_changes_description = /** @type {(inputs: Snap_To_Shot_Changes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure settings for snapping events to shot changes`)
};

const fr_snap_to_shot_changes_description = /** @type {(inputs: Snap_To_Shot_Changes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurer les paramètres pour aligner les événements sur les changements de plan`)
};

const de_snap_to_shot_changes_description = /** @type {(inputs: Snap_To_Shot_Changes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfigurieren Sie die Einstellungen für das Ausrichten von Ereignissen an Aufnahmeänderungen`)
};

const it_snap_to_shot_changes_description = /** @type {(inputs: Snap_To_Shot_Changes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurare le impostazioni per agganciare gli eventi alle modifiche di ripresa`)
};

const ru_snap_to_shot_changes_description = /** @type {(inputs: Snap_To_Shot_Changes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройте параметры привязки событий к изменениям ракурса съемки.`)
};

const es_snap_to_shot_changes_description = /** @type {(inputs: Snap_To_Shot_Changes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurar ajustes para ajustar eventos a cambios de toma`)
};

const zh_cn2_snap_to_shot_changes_description = /** @type {(inputs: Snap_To_Shot_Changes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配置捕捉事件以拍摄更改的设置`)
};

const ja_snap_to_shot_changes_description = /** @type {(inputs: Snap_To_Shot_Changes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショットの変更にイベントをスナップするための設定を構成する`)
};

const hi_snap_to_shot_changes_description = /** @type {(inputs: Snap_To_Shot_Changes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट परिवर्तन के अनुसार इवेंट स्नैप करने के लिए सेटिंग्स कॉन्फ़िगर करें`)
};

const pt_pt2_snap_to_shot_changes_description = /** @type {(inputs: Snap_To_Shot_Changes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure as definições para sincronizar eventos com alterações de disparo.`)
};

/**
* | output |
* | --- |
* | "Configure settings for snapping events to shot changes" |
*
* @param {Snap_To_Shot_Changes_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snap_to_shot_changes_description = /** @type {((inputs?: Snap_To_Shot_Changes_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snap_To_Shot_Changes_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snap_to_shot_changes_description(inputs)
	if (locale === "de") return de_snap_to_shot_changes_description(inputs)
	if (locale === "it") return it_snap_to_shot_changes_description(inputs)
	if (locale === "ru") return ru_snap_to_shot_changes_description(inputs)
	if (locale === "es") return es_snap_to_shot_changes_description(inputs)
	if (locale === "zh-CN") return zh_cn2_snap_to_shot_changes_description(inputs)
	if (locale === "ja") return ja_snap_to_shot_changes_description(inputs)
	if (locale === "hi") return hi_snap_to_shot_changes_description(inputs)
	if (locale === "pt-PT") return pt_pt2_snap_to_shot_changes_description(inputs)
	return en_snap_to_shot_changes_description(inputs)
});